import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import { DashboardPerformanceChart } from '../../../dashboard/components/DashboardPerformanceChart';
import { DashboardWidgetAction } from '../../../dashboard/model';
import { serializePerformanceAnalyzerRouteSearch } from '../../../reporting/performanceAnalyzer/performanceAnalyzerRouteSearch';
import type { networkDashboardRuntime } from './widgetRuntime';
import { NetworkDashboardWidgetType, type NetworkDashboardWidget } from './widgetModel';

export function NetworkPerformanceRenderer({
  widget,
  runtime,
}: dashboardCanvasRendererProps<NetworkDashboardWidget, networkDashboardRuntime>) {
  if (widget.type !== NetworkDashboardWidgetType.PerformanceChart) return null;
  return (
    <DashboardPerformanceChart
      overview={runtime.overview.data}
      metrics={widget.metrics}
      range={runtime.range}
      loading={runtime.overview.isLoading}
      error={runtime.overview.isError}
      actions={widget.actions}
      performanceAnalyzerSearch={
        widget.actions.includes(DashboardWidgetAction.PerformanceAnalyzer)
          ? serializePerformanceAnalyzerRouteSearch(runtime.range)
          : null
      }
    />
  );
}
